export function getEnv(name: string): string | undefined {
  return (window as any)?.configs?.[name] || import.meta.env[name]
}

// Форматирование цены для отображения в интерфейсе
export const formatPrice = (value?: string | number, isAddZeros?: boolean): undefined | string => {
  if (value || value === 0 || value === '0') {
    let valueFloat
    if (typeof value === 'string') {
      valueFloat = parseFloat(value)
      if (isNaN(valueFloat)) {
        return ''
      }
    } else {
      valueFloat = value
    }

    let str
    if (isAddZeros) {
      str = valueFloat.toFixed(2)
    } else {
      str = (Math.floor(valueFloat * 100) / 100).toString()
    }

    return str.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  return ''
}

export function removeNonNumericChars(s: string): string {
  return s.replace(/\D/g, '')
}
